const mapIdToName = require('./map-data');
const Hammer = require('./hammer');

module.exports = function mapSVG({
  element,
  onClickFunction
}) {
  const $container = $(element);
  var pt; //sử dụng để tính toạ độ mouse
  if (!$container) return;
  let map;
  const getMapSize = function () {
    const sizes = map.getSizes();
    const pan = map.getPan();
    const zoom = map.getZoom();
    return {
      sizes,
      pan,
      zoom
    }
  }

  /**
   * Function này để restore lại thông tin vị trí và độ zoom của map.
   * @param {*} param0 
   */
  const restoreMapSize = function ({ sizes, pan, zoom } = {}) {
    if (!sizes || !pan || !zoom) {
      const oldMapSize = JSON.parse($container.find("input[name='map-size']").val() || "{}");
      sizes = oldMapSize?.sizes
      pan = oldMapSize?.pan
      zoom = oldMapSize?.zoom
    }
    if (!sizes || !pan || !zoom) return;
    map.resize();
    map.reset();
    const newSizes = getMapSize();
    const ratio = newSizes.sizes.width / sizes.width;
    const newPan = { x: pan.x * ratio, y: pan.y * ratio };
    map.zoom(zoom);
    map.pan(newPan);
  }

  const getMapData = function () {
    let data = JSON.parse($container.find("input[name='map-data']").val() || "{}");
    return data
  }
  const setMapData = function (data) {
    $container.find("input[name='map-data']").val(JSON.stringify(data))
  }

  const restoreMapData = function () {
    try {
      const data = getMapData()
      // console.log("restore data:", data);
      const $svgMap = $container.find("#vnmap-svg");
      $svgMap.find(".province").attr("fill", '#D9D9D9');
      $svgMap.find(".icon-group .icon").remove();

      for (let id in data) {
        let { icon, color } = data[id];
        if (!icon) icon = 'circle';
        const $path = $svgMap.find(`#${id}`).attr("fill", color);
        const pathBBox = $path[0].getBBox();
        // console.log(pathBBox);
        iconSize = 50;//Math.max(0.3 * pathBBox.width, 24);

        const iconPosition = {
          x: pathBBox.x + (pathBBox.width / 2 - iconSize / 2),
          y: pathBBox.y + (pathBBox.height / 2 - iconSize / 2)
        };

        const iconElement = $svgMap.find(`.${icon}-origin`).clone().removeClass(`${icon}-origin`).addClass(`province icon ${icon}`).data("id", id)
          .css("transform", `translate(${iconPosition.x}px, ${iconPosition.y}px) scale(${iconSize / 24})`);
        $svgMap.find(".svg-pan-zoom_viewport .icon-group").append(iconElement);

      }
    }
    catch (e) {
      console.error(e)
    }
  }

  const isMobile = function() {
    let check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
    return check;
  };


  const bindingEventOnClick = function (thisObject, callback) {
    const $svgMap = $container.find("#vnmap-svg");
    // $svgMap.on("click touchstart", ".province", function () {
    //   console.log("touchstart")
    //   const id = $(this).attr("id") || $(this).data("id");
    //   const name = mapIdToName[id]?.name
    //   console.log("name", name, callback)
    //   if (typeof callback == "function") {
    //     callback(thisObject, id, name)
    //   }
    // })
    $svgMap.on("mouseover", ".province", function (event) {
      console.log("mouseover")
      const fill = $(this).attr("fill") || $(this).find('path').attr("stroke") || $(this).find('circle').attr("stroke");
      if(fill !== "#029B5C" && isMobile()) return
      const id = $(this).attr("id") || $(this).data("id");
      const name = mapIdToName[id]?.name
      const elem = $container.find(".hover-box");
      const text = elem.find("text");
      text.html(name);
      makeBG(text[0]);
      const position = cursorPoint(pt, $svgMap[0], getMapSize(), event);
      $(elem).fadeIn('slow').css('transform', `translate(${position.x}px, ${position.y}px)`)
    });
    $svgMap.on("mouseleave", function (event) {
      const elem = $container.find(".hover-box");
      $(elem).fadeOut('slow');
    });
  }
  /**
  * Init
  */
  function init(thisObject) {
    const svgMap = $container.find("#vnmap-svg");
    pt = svgMap[0].createSVGPoint();

    var eventsHandler = {
      haltEventListeners: ['touchstart', 'touchend', 'touchmove', 'touchleave', 'touchcancel'], 
      init: function(options) {
        var instance = options.instance,
          initialScale = 1,
          pannedX = 0,
          pannedY = 0;

        // Init Hammer
        // Listen only for pointer and touch events
        this.hammer = Hammer(options.svgElement, {
          inputClass: Hammer.SUPPORT_POINTER_EVENTS ? Hammer.PointerEventInput : Hammer.TouchInput
        })

        // Enable pinch
        this.hammer.get('pinch').set({enable: true})

        // Handle double tap
        this.hammer.on('doubletap', function(ev){
          instance.zoomIn()
        })

        // Handle pan
        this.hammer.on('panstart panmove', function(ev){
          // On pan start reset panned variables
          if (ev.type === 'panstart') {
            pannedX = 0
            pannedY = 0
          }

          // Pan only the difference
          instance.panBy({x: ev.deltaX - pannedX, y: ev.deltaY - pannedY})
          pannedX = ev.deltaX
          pannedY = ev.deltaY
        })

        // Handle pinch
        this.hammer.on('pinchstart pinchmove', function(ev){
          // On pinch start remember initial zoom
          if (ev.type === 'pinchstart') {
            initialScale = instance.getZoom()
            instance.zoomAtPoint(initialScale * ev.scale, {x: ev.center.x, y: ev.center.y})
          }

          instance.zoomAtPoint(initialScale * ev.scale, {x: ev.center.x, y: ev.center.y})
        })

        // Prevent moving the page on some devices when panning over SVG
        options.svgElement.addEventListener('touchmove', function(e){ e.preventDefault(); });
      }, 
      destroy: function(){
        this.hammer.destroy()
      }
    }

    map = svgPanZoom(svgMap[0], {
      panEnabled: true,
      zoomEnabled: true,
      controlIconsEnabled: true,
      dblClickZoomEnabled: false,
      minZoom: 0.8,
      maxZoom: 10,
      onPan: () => {
        $container.find("input[name='map-size']").val(JSON.stringify(getMapSize()))
      },
      onZoom: () => {
        $container.find("input[name='map-size']").val(JSON.stringify(getMapSize()))
      },
      customEventsHandler: eventsHandler
    });

    //khởi tạo sự kiện onclick
    bindingEventOnClick(thisObject, onClickFunction)

    map.resize();
    map.reset();
    restoreMapData();
    map.getMapSize = getMapSize;
    map.restoreMapSize = restoreMapSize;
    map.restoreMapData = restoreMapData;
    map.getMapData = getMapData()
    $container["map"] = map;
    window.map = map;
  }
  const thisObject = {
    getMapSize,
    restoreMapSize,
    getMapData,
    setMapData,
    restoreMapData,
    $container
  }
  init(thisObject);

  return thisObject
}
function makeBG(elem) {
  var svgns = "http://www.w3.org/2000/svg"
  var bounds = elem.getBBox()
  $(elem).parent().find("rect").remove()
  var bg = document.createElementNS(svgns, "rect")
  var style = getComputedStyle(elem)
  var padding_top = parseInt(style["padding-top"])
  var padding_left = parseInt(style["padding-left"])
  var padding_right = parseInt(style["padding-right"])
  var padding_bottom = parseInt(style["padding-bottom"])
  bg.setAttribute("x", bounds.x - parseInt(style["padding-left"]))
  bg.setAttribute("y", bounds.y - parseInt(style["padding-top"]))
  bg.setAttribute("width", bounds.width + padding_left + padding_right)
  bg.setAttribute("height", bounds.height + padding_top + padding_bottom)
  bg.setAttribute("fill", style["background-color"])
  bg.setAttribute("rx", style["border-radius"])
  bg.setAttribute("stroke-width", style["border-top-width"])
  bg.setAttribute("stroke", style["border-top-color"])
  if (elem.hasAttribute("transform")) {
    bg.setAttribute("transform", elem.getAttribute("transform"))
  }
  elem.parentNode.insertBefore(bg, elem)
}
function cursorPoint(pt, svg, mapSize, evt) {
  const scale = mapSize.sizes.realZoom;
  pt.x = evt.clientX; pt.y = evt.clientY;
  let position = pt.matrixTransform(svg.getScreenCTM().inverse());
  return {
    x: (position.x - mapSize.pan.x) * 1 / scale + 50,
    y: (position.y - mapSize.pan.y) * 1 / scale
  }
}